const ROUTES = {
  INDEX: '/',
  // Order pages
  ORDERS: '/order',
  ORDER_DETAIL: '/order/:id',
  // Invoices
  INVOICES: '/invoice',
  // Catalog table pages
  PROVIDER_INFOS: '/material',
  CREATE_PROVIDER_INFO: '/material/create',
  EDIT_PROVIDER_INFO: '/material/edit',
  PRICINGS: '/pricing',
  CREATE_PRICING: '/pricing/create',
  EDIT_PRICING: '/pricing/edit',
  INFILLS: '/infill',
  TOLERANCES: '/tolerance',
  PRODUCTION_TIMES: '/production-time',
  DYNAMIC_PRODUCTION_TIMES: '/dynamic-production-time',
  CREATE_DYNAMIC_PRODUCTION_TIMES: '/dynamic-production-time/create',
  EDIT_DYNAMIC_PRODUCTION_TIMES: '/dynamic-production-time/edit',
  SHIPPINGS: '/shipping',
  DISCOUNTS: '/discount',
  // Account pages
  SETTINGS: '/settings',
  SIGN_IN: '/signin',
  SIGN_IN_ADMIN: '/signin-admin',
  RESET_PASSWORD: '/reset-password',
  // Others
  FORBIDDEN: '/forbidden',
}

export default ROUTES
